import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
/// <reference types="@angular/localize" />

async function bootstrap() {
    const config = await appConfig();
    return bootstrapApplication(AppComponent, config).catch((err) => console.error(err));
}
bootstrap();
